const EMAIL_VERIFIED_KEY = 'emailVerificationCompletedAt'

/** Tells the customer's other open tabs that their email has just been verified in this one. */
export function broadcastEmailVerified(): void {
  try {
    window.localStorage.setItem(EMAIL_VERIFIED_KEY, String(Date.now()))
  } catch {
    // Storage can be unavailable (privacy modes); other tabs then pick it up on focus or reload
  }
}

/**
 * Calls `onVerified` when another tab verifies the customer's email. `storage` events only fire in
 * tabs other than the one that wrote the value. Returns an unsubscribe function.
 */
export function onEmailVerifiedInAnotherTab(onVerified: () => void): () => void {
  const onStorage = (event: StorageEvent) => {
    if (event.key === EMAIL_VERIFIED_KEY && event.newValue) onVerified()
  }
  window.addEventListener('storage', onStorage)
  return () => window.removeEventListener('storage', onStorage)
}
